import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { Typography, Box, Button, CircularProgress } from '@material-ui/core'
import { Check } from '@material-ui/icons/'
import styled from 'styled-components'
import ContextConsumer from '../Context'
import { formatPrice } from '../../utils/helpers'
import { updateUserBalance } from './utilities.js'

// 1. Will need to remove itself from open bets
// 2. Will need to update history to say it was cashed out

// Move the top margin to the bet card component
const CashOutButton = styled(Button)`
  background-color: ${props => props.theme.palette.oddsButton.default};
  color: ${props => props.theme.palette.primary.main};
  margin-top: ${props => props.theme.spacing(2)}px;

  &:hover {
    background-color: ${props => props.theme.palette.oddsButton.hover};
  }
`
const CheckIcon = styled(Check)`
  margin-right: ${props => props.theme.spacing(2)}px;
`
const Progress = styled(CircularProgress)`
  margin: ${props => props.theme.spacing(1)}px auto;
`

const CashOut = props => {
  const { betKey, betDetails } = props
  const { stake, straight } = betDetails
  const [state, setState] = useState()

  // create a timer variable to simulate loading
  const loadingTimer = useRef()

  // Cleanup the timer used for simulated loading
  useEffect(
    () => () => {
      clearTimeout(loadingTimer.current)
    },
    []
  )

  const offer = (stake || straight.stake) * 0.8

  return (
    <ContextConsumer>
      {({ data, set }) => {
        // Handle cash out
        const updateUserHistory = () => {
          const user = { ...data.user }
          const { history } = data.user

          loadingTimer.current = setTimeout(() => {
            history[`${betKey}`] = {
              ...betDetails,
              cashedOutAmount: offer, // cashed out, win, lose
              result: 'cashed-out',
            }
            set({ user })
          }, 2000)
        }
        const handleConfirm = () => {
          setState('loading')
          loadingTimer.current = setTimeout(() => {
            // can do checks here to send to either price update or confirm
            updateUserBalance(data, set, -offer)
            setState('success')
            updateUserHistory()
          }, 2000)
        }

        if (state === 'loading') {
          return (
            <Box textAlign="center" pt={2}>
              <Progress color="primary" size="24px" thickness={5} />
            </Box>
          )
        }
        if (state === 'confirm') {
          return (
            <Box width="100%">
              <Box py={4}>
                <Typography
                  variant="subtitle2"
                  display="block"
                  align="center"
                  color="textSecondary"
                >
                  Are you sure you want to cash out for{' '}
                  {formatPrice(offer * 100)}
                </Typography>
              </Box>
              <Box display="flex">
                <Button
                  onClick={() => setState('default')}
                  color="primary"
                  fullWidth
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  onClick={handleConfirm}
                  color="primary"
                  fullWidth
                >
                  Confirm
                </Button>
              </Box>
            </Box>
          )
        }
        if (state === 'success') {
          return (
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              pt={4}
              width={1}
              color="success.main"
            >
              <CheckIcon />
              <Typography variant="body1" display="block">
                Cashed out @ {formatPrice(offer * 100)}
              </Typography>
            </Box>
          )
        }
        return (
          <CashOutButton
            variant="contained"
            fullWidth
            onClick={() => setState('confirm')}
          >
            CashOut {formatPrice(offer * 100)}
          </CashOutButton>
        )
      }}
    </ContextConsumer>
  )
}

CashOut.propTypes = {
  betKey: PropTypes.string,
  betDetails: PropTypes.object,
}

export default CashOut
